




// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from 'firebase/auth'
//import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD520rkHSLu_JLd2ZNfdBdrkLZn9XV-NbU",
  authDomain: "myclone-245ac.firebaseapp.com",
  projectId: "myclone-245ac",
  storageBucket: "myclone-245ac.appspot.com",
  messagingSenderId: "824225029887",
  appId: "1:824225029887:web:ab563261a43bc8468836ca",
  measurementId: "G-TWPGCD62HH"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const auth= getAuth(app)
//const analytics = getAnalytics(app);
export {auth}